export default {
  situacao: {
    value: '',
    options: [
      { text: 'Perda', value: 'PERDIDO' },
      { text: 'Finalização', value: 'FINALIZADO' }
    ],
    required: true,
    state: null
  },
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/board/reason/components/add/reasonadd-form.js